import DqAcceptablespanel from './src/acceptablespanel'

/* istanbul ignore next */
DqAcceptablespanel.install = function (Vue) {
  Vue.component(DqAcceptablespanel.name, DqAcceptablespanel)
}

export default DqAcceptablespanel



// WEBPACK FOOTER //
// ./src/dq-ui/packages/acceptablespanel/acceptablespanel.js